import ConfirmationModal from "@/modules/common/components/modals/cofirmation-modal";
import useAutoAssign from "@/modules/lead-page/hooks/lead-info/lead-actions/auto-assign.hook";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import { Box, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";

const AutoAssign = () => {
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const { lead } = useContext(LeadPageContext);

  const { isLoadingAutoAssign, handleAutoAssign, isError, isSuccess } =
    useAutoAssign();

  // Check if lead is marked as rubbish
  const isLeadInvalidClient = lead?.data?.lead?.rubbish === true;

  useEffect(() => {
    if (isSuccess) {
      toast.success("Lead auto-assigned successfully", {
        position: "bottom-left",
      });
      setConfirmationModalOpen(false);
    }
    if (isError) {
      toast.error("Something went wrong", {
        position: "bottom-left",
      });
    }
  }, [isError, isSuccess]);

  return (
    <>
      <ConfirmationModal
        open={confirmationModalOpen}
        setOpen={setConfirmationModalOpen}
        onConfirmHandler={handleAutoAssign}
        isLoading={isLoadingAutoAssign}
        disableConfirmButton={isLeadInvalidClient}
        title={isLeadInvalidClient ? "Cannot Auto-Assign" : "Auto-Assign Lead"}
        body={
          isLeadInvalidClient
            ? "Please mark the lead as a Valid client before assigning"
            : "Are you sure you want to auto-assign this lead?"
        }
      />

      <Box
        sx={{
          display: "flex",
          gap: nawyTheme.nawy.spacing.xs,
          padding: nawyTheme.nawy.spacing.xs,
          alignItems: "center",
          width: "100%",
          height: "100%",
          cursor: "pointer",
          color: nawyTheme.nawy.colors.semantic.text.primary,
          ":hover": {
            backgroundColor: nawyTheme.nawy.colors.semantic.layer.secondary,
          },
        }}
        onClick={() => setConfirmationModalOpen(true)}
      >
        <Typography
          sx={{
            color: nawyTheme.nawy.colors.semantic.text.primary,
            ...nawyTheme.nawy.typography.english.variants.body.md.regular,
          }}
        >
          Auto Assign
        </Typography>
      </Box>
    </>
  );
};

export default AutoAssign;
